export default __webpack_public_path__ + "static/media/Failed.f5050c31.svg";